
import { defineComponent, ref, watch } from "vue";
import {
    onBeforeRouteLeave,
    onBeforeRouteUpdate,
    RouterLink,
    useRoute,
    useRouter,
} from "vue-router";
import { ElMessage, vLoading } from "element-plus";
import { CommentList } from "@/components/Comment";

import ArticleListItem from "@/components/ArticleListItem";
import { UserTag, StyleTag } from "@/components/common";

import { online_link_name } from "@/basics/enums";
import { formatTS } from "@/utility";
import markdown from "@/markdown/renderMD";
import { useStore, useUserInfo } from "@/store";
import { AlbumId, AlbumModel, ArticleId, ArticleModel, VersionAlbumModel } from "@/typings";
import {
    getRankVersionRelatedArticle,
    getArticleVersionAlbum,
    doSendCounterView,
    albumRateHeart,
} from "@/services";
import wx from "@/basics/wx";
import ajax from "@/basics/fetch";
import wechatTitle from "@/directives/wechat-title";

export default defineComponent({
    directives: {
        vLoading,
        wechatTitle,
    },
    components: {
        ArticleListItem,
        CommentList,
        RouterLink,
        StyleTag,
        UserTag,
    },
    setup() {
        const userInfo = useUserInfo();
        const route = useRoute();
        const article_id = ref("" as ArticleId);
        const album_id = ref("" as AlbumId);
        const loading = ref(false);
        const article = ref<
            | (VersionAlbumModel & {
                  album_data: AlbumModel;
              })
            | null
        >(null);

        const articles = ref<ArticleModel[]>([]);
        const article_loading = ref(false);
        // const pagination_rocknut = reactive({
        //     pageNow: 1,
        //     total: 1
        // });

        const refreshRocknutData = () => {
            article_loading.value = true;
            if (article.value == null) {
                return;
            }
            getRankVersionRelatedArticle(
                article.value.main_version_id._id,
                article.value.main_rank_id._id,
            )
                .then((json) => {
                    articles.value = json.data.articles;
                })
                .finally(() => {
                    article_loading.value = false;
                });

            // getArticleRelatedArticle(article_id.value, {
            //     page: pagination_rocknut.pageNow
            // }).then((json) => {
            //     articles.value = json.data.articles.filter((item) => {
            //         return item._id !== article_id.value;
            //     });
            //     pagination_rocknut.total = json.data.pages.total;
            // }).finally(() => {
            //     article_loading.value = false;
            // });
        };

        const handlerTimeout = ref(0);
        const clearTimeout = () => {
            handlerTimeout.value && window.clearTimeout(handlerTimeout.value);
        };

        const refreshData = (id: ArticleId) => {
            if (!id) {
                return;
            }
            article_id.value = id;

            getArticleVersionAlbum(id).then((json) => {
                article.value = {
                    ...json.data.article,
                    album_data: json.data.album,
                };
                wx.wxConfig(ajax, {
                    title: article.value.title,
                    desc: article.value.content.substring(0, 30),
                    imgUrl: article.value.album_data.primary_img,
                });
                album_id.value = article.value.album_data._id;
                refreshRocknutData();

                handlerTimeout.value = window.setTimeout(() => {
                    doSendCounterView(article.value!);
                }, 5000);
            });
        };

        onBeforeRouteUpdate(clearTimeout);
        onBeforeRouteLeave(clearTimeout);

        watch(
            () => {
                return route.params.article_id as ArticleId;
            },
            refreshData,
            {
                immediate: true,
            },
        );

        const router = useRouter();
        const goEditArticle = () => {
            router.push({
                path: "rank/version/write/" + article.value?.main_version_id._id,
            });
        };

        const store = useStore();
        const now_heart = ref(0);
        const heart_loading = ref(false);
        const doHeart = (rate: number) => {
            if (!store.state.isLogin) {
                ElMessage.error("请先登录");
                return;
            }
            now_heart.value = rate;
            heart_loading.value = true;
            albumRateHeart({
                album_id: album_id.value,
                rate,
            })
                .then((json) => {
                    article.value!.album_data.hot_index = json.data.hot_index;
                    article.value!.album_data.counter_heart_1 = json.data.counter_heart_1;
                    article.value!.album_data.counter_heart_2 = json.data.counter_heart_2;
                })
                .catch((json) => {
                    ElMessage.error(json.data.msg);
                })
                .finally(() => {
                    heart_loading.value = false;
                });
        };

        return {
            loading,
            online_link_name,
            formatTS,
            markdown,
            userInfo,
            article,
            articles,
            goEditArticle,
            now_heart,
            doHeart,
        };
    },
});
